<template>
	<div>
		<div class="content mt-5" id="style-props">
			<p>Customize the style using simple attributes:</p>
			<ul>
				<li><code>bordered</code> toggle all table borders</li>
				<li><code>striped</code> toggle striped style on rows</li>
				<li><code>dense</code> reduces the height of the rows, compacting the table</li>
				<li><code>hoverable</code> highlight row on hover</li>
				<li><code>borderless</code> removes all borders from the table</li>
				<li><code>fixedLayout</code> apply <code>layout: fixed</code> style to the table</li>
			</ul>
			<p>In addition, you can customize the classes and the size of the table:</p>
			<ul>
				<li><code>width</code>, <code>maxWidth</code>, <code>height</code> and <code>maxHeight</code> to customize the size of the container</li>
				<li><code>containerClass</code> applied to the table container</li>
				<li><code>tableClass</code> applied to the table itself</li>
			</ul>
			<p>And the style of any column:</p>
			<ul>
				<li><code>width</code> set the width of the column and activate the fixed layout on the table</li>
				<li><code>headerClass</code> applied to table headers</li>
				<li><code>cellClass</code> applied to table content</li>
				<li><code>fit</code> causes the column to adapt to the content (disabled if fixed-layout)</li>
				<li><code>grow</code> causes the column to widen as much as possible (disabled if fixed-layout)</li>
			</ul>
			<pre v-highlightjs class="box pa-0"><code class="html">&lt;ui-table :items=&quot;items&quot;
				  :bordered=&quot;bordered&quot;
				  :striped=&quot;striped&quot;
				  :dense=&quot;dense&quot;
				  :hoverable=&quot;hoverable&quot;
				  :borderless=&quot;borderless&quot;
				  :fixed-layout=&quot;fixedLayout&quot;&gt;
	&lt;ui-table-column prop=&quot;id&quot; fit/&gt;
	&lt;ui-table-column prop=&quot;title&quot;/&gt;
	&lt;ui-table-column prop=&quot;body&quot; grow/&gt;
&lt;/ui-table&gt;</code></pre>
		</div>
		<div class="box">
			<div class="level">
				<div class="level-item">
					<label class="checkbox" :disabled="borderless">
						<input type="checkbox" v-model="bordered" :disabled="borderless">
						bordered
					</label>
				</div>
				<div class="level-item">
					<label class="checkbox">
						<input type="checkbox" v-model="striped">
						striped
					</label>
				</div>
				<div class="level-item">
					<label class="checkbox">
						<input type="checkbox" v-model="dense">
						dense
					</label>
				</div>
				<div class="level-item">
					<label class="checkbox">
						<input type="checkbox" v-model="hoverable">
						hoverable
					</label>
				</div>
				<div class="level-item">
					<label class="checkbox" :disabled="bordered">
						<input type="checkbox" v-model="borderless" :disabled="bordered">
						borderless
					</label>
				</div>
				<div class="level-item">
					<label class="checkbox">
						<input type="checkbox" v-model="fixedLayout">
						fixed layout
					</label>
				</div>
			</div>
			<ui-table :items="items"
					  :bordered="bordered"
					  :striped="striped"
					  :dense="dense"
					  :hoverable="hoverable"
					  :borderless="borderless"
					  :fixed-layout="fixedLayout">
				<ui-table-column prop="id" fit/>
				<ui-table-column prop="title"/>
				<ui-table-column prop="body" grow/>
			</ui-table>
		</div>
	</div>
</template>

<script>
    export default {
        name: "style-props",
        props: {
            items: Array
        },
		data() {
            return {
                bordered: false,
                striped: false,
                dense: false,
                hoverable: false,
                borderless: false,
                fixedLayout: false
			}
		}
    }
</script>